import React, { FC } from 'react';
import { Tooltip } from 'antd';
import { InfoGrey, Package } from 'common/svg';
import { countFormatter } from 'common/helpers';

interface IComponentProps {
  availableCount: number;
  totalCount: number;
}

export const InventoryAvailableCount: FC<IComponentProps> = ({ availableCount, totalCount }) => {
  return (
    <div className="flex align-center">
      <div className="inventory-count mr-3">
        <Package className="icon-package-bright-green" />

        <span className="ff-medium fs-xs">{`Свободно: ${availableCount} из ${countFormatter(totalCount)}`}</span>
      </div>

      <Tooltip
        overlayClassName="redesign"
        title="Свободное оборудование — не закреплено за сотрудниками и не имеет активных запросов на списание или передачу."
        overlayStyle={{ width: 250 }}
      >
        <InfoGrey className="icon-info-grey" />
      </Tooltip>
    </div>
  );
};
